import { formatEntityName, formatRoleName } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
import { buildOperations, validateRole } from '../../utils';
export const aclAllowEntityStmtInstruction = `
#### Allowing access to entities
- Syntax: \`allow <roleName1>[, <roleName2>] to <accessTypes> entity <entityName>;\`
- Example: \`allow public to read entity Article;\`
- Example: \`allow editor to read, create, update, delete entity Article;\`
- Example: \`allow public, editor to read entity article;\`
`;
export const stmtAclAllowEntity = ({ roleNames, accessTypes, entityName }) => {
    return `allow ${roleNames.join(', ')} to ${accessTypes.join(', ')} entity ${entityName};`;
};
export const stmtForHumanAclAllowEntity = ({ roleNames, accessTypes, entityName }) => {
    return `Allow the roles __${roleNames.join(', ')}__ to ${accessTypes.join(', ')} the entity __${entityName}__.`;
};
export const aclAllowEntityHandler = createSchemaStatementHandler({
    type: 'allow entity',
    parse: line => {
        const match = /^allow (?<roleNames>[\w, ]+) to (?<accessTypes>[\w, ]+) entity (?<entityName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'allow entity',
                roleNames: match.groups.roleNames.split(',').map(it => formatRoleName(it.trim())),
                accessTypes: match.groups.accessTypes
                    .split(',')
                    .map(item => item.trim())
                    .filter((it) => ['delete', 'create', 'update', 'read'].includes(it)),
                entityName: formatEntityName(match.groups.entityName),
            }
            : null;
    },
    getHumanStmt: stmtForHumanAclAllowEntity,
    apply: (stmt, builder) => {
        builder.updateSchema(it => {
            const entity = it.schema.model.entities[stmt.entityName];
            if (!entity) {
                throw new Error(`Entity ${stmt.entityName} does not exist. Cannot allow access to it.`);
            }
            let updatedSchema = it;
            for (const role of stmt.roleNames) {
                validateRole(role);
                const operations = buildOperations({ entity, accessTypes: stmt.accessTypes, predicate: true });
                updatedSchema = updatedSchema.createAclRole(role).updatePermissionsEntity(role, stmt.entityName, {
                    predicates: {},
                    operations,
                });
            }
            return updatedSchema;
        });
    },
});
//# sourceMappingURL=AclAllowEntityStmt.js.map